import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { Utils } from '../../Utils/Utils';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';

export interface IndexPageOptions extends PageOptionsBase {
    urlGeneratePresentationLink: string;
}

export class IndexPage extends PageBase<IndexPageOptions> {

    private _btnGenerate: JQuery;
    private _btnCopy: JQuery;

    constructor(options: IndexPageOptions) {
        super(options);
        this.generateLink = this.generateLink.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
    }

    init(): void {
        this._btnGenerate = Utils.getJQueryById("btnGenerate");
        this._btnGenerate.on("click", this.generateLink);
        this._btnCopy = Utils.getJQueryById("btnCopy");
        this._btnCopy.on("click", this.copyToClipboard);
    }

    private generateLink(): void {
        let gameCode = $('#gameCode').val();
        if (Utils.isNullOrUndefined(gameCode) || gameCode === "") {
            return;
        }
        let url = this._options.urlGeneratePresentationLink;
        var statusMessage = Utils.getJQueryById("statusMessageWrapper");
        $.ajax({
            url: url,
            type: "GET",
            data: { 'gameCode': gameCode },
            success: function (data) {
                if (Utils.isNullOrUndefined(data.generatedLink)) {
                    statusMessage.html(data);
                    StatusMessageHelper.initValidator();
                    StatusMessageHelper.initSatusMessage();
                }
                else {
                    $('#generatedLink').text(data.generatedLink);
                    document.getElementById("linkValidity").innerText = `${data.validTo} UTC`;
                }
            },
        });
    }

    private copyToClipboard(): void {
        let textToCopy = $('#generatedLink');
        textToCopy.select();
        document.execCommand("copy");
    }
}



/** WEBPACK FOOTER **
 ** ./Typescript/Pages/GamePresentation/IndexPage.ts
 **/